import Ajax from '../ajax';

export default {
  list: (filter) => Ajax('get', 'user', filter),
  get: (id) => Ajax('get', `user/${id}`),
  add: (parameter) => Ajax('post', 'user', parameter),
  edit: (id, parameter) => Ajax('put', `user/${id}`, parameter),
  listInvitedUsers: (id, filter) => Ajax('get', `user/${id}/invited`, filter),
  forgotPassword: (id) => Ajax('put', `user/${id}/password`),
  forgotTranPassword: (id) => Ajax('put', `user/${id}/tranPassword`),
  listPoints: (id, filter) => Ajax('get', `user/${id}/points`, filter),
  getPoint: (id, tid) => Ajax('get', `user/${id}/points/${tid}`),
  addPoints: (id, parameter) => Ajax('post', `user/${id}/points`, parameter),
  listSms: (id, filter) => Ajax('get', `user/${id}/sms`, filter),
  listSignInLogs: (id, filter) => Ajax('get', `user/${id}/signInLogs`, filter),
  authList: (filter) => Ajax('get', 'user/auth', filter),
  auth: (id, parameter) => Ajax('put', `user/${id}/auth`, parameter),
};
